import { legacyColors } from '~/legacyTheme';
import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    dialogSize: {
      minWidth: '800px',
      minHeight: '446px',
    },
    backdrop: {
      color: legacyColors.white,
      zIndex: theme.zIndex.drawer + 1,
    },
  };
};
